import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function SeenLog({ v }) {
  if (!v.showSeenLog) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeSeenLog}>
        <div className="gp-venster gp-vast" style={{ "width": "min(560px,100%)", "maxHeight": "min(78vh,680px)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Wie was wanneer online
              </div>
            </div>
            <button onClick={v.closeSeenLog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div style={{ "flex": "1 1 auto", "minHeight": "0", "overflow": "auto", "display": "flex", "flexDirection": "column", "gap": "8px", "paddingRight": "2px" }}>
            {toList(v.seenLog).map((s, $index) => (
              <React.Fragment key={$index}>
                <div style={css(s?.rowStyle)}>
                  {' '}
                  <img alt="" src={s?.avatarUrl} style={{ "width": "34px", "height": "34px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                  {' '}
                  <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
                    <div style={{ "display": "flex", "alignItems": "center", "gap": "7px", "minWidth": "0" }}>
                      <span style={css(s?.dotStyle)} />
                      <span style={{ "fontSize": "14px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={s?.name} />
                      </span>
                    </div>
                    <div style={{ "display": "flex", "alignItems": "center", "gap": "7px", "flexWrap": "wrap", "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-2)", "fontVariantNumeric": "tabular-nums" }}>
                      <span>
                        <Interp v={s?.stamp} />
                      </span>
                      <span style={{ "width": "3px", "height": "3px", "borderRadius": "50%", "background": "var(--rand-stippel)", "flex": "0 0 auto" }} />
                      <span>
                        <Interp v={s?.today} />
                      </span>
                    </div>
                  </div>
                  {' '}
                  <span style={css(s?.whenStyle)}>
                    <Interp v={s?.when} />
                  </span>
                  {' '}
                </div>
              </React.Fragment>
            ))}
          </div>
          <div style={{ "flex": "0 0 auto", "display": "flex", "flexDirection": "column", "gap": "10px" }}>
            {v.showSeenLogHint ? (<>
              <span style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--fout)" }}>
                Voeg op de server aan paal_accounts een getalveld “activeSec” en een tekstveld “activeDay” toe om de tijd te kunnen bijhouden.
              </span>
            </>) : null}
            <button onClick={v.closeSeenLog} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
              Klaar
            </button>
          </div>
        </div>
      </div>
      {' '}
    </>
  );
}
